import { Link } from "react-router-dom";

const VPSHostingContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Stay Connected to the Market, Always</h2>
              <p>
                Whether you’re executing automated strategies or monitoring open
                positions, The Pips VPS ensures uninterrupted performance. Enjoy
                peace of mind knowing your trading systems are running securely
                and efficiently, even during power outages or system restarts.
                With ultra-low latency connections, your orders reach the market
                faster, improving accuracy and execution quality. Advanced
                encryption and server-level protections safeguard your data at
                all times. No matter your trading style, The Pips VPS keeps you
                connected, protected, and fully in control of every move you
                make.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Activate VPS Hosting
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/vps_hosting/vps_hosting_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VPSHostingContentThree;
